import { useApi } from './useApi';
import { useAppState } from './useAppState';
export function useProducts() {
    const api = useApi();
    const state = useAppState();
    function getProducts(employerId, onSuccess = null) {
        state.products = [];
        if (employerId) {
            state.benefits = [];
        }
        state.calculators = [];
        state.marketplace = [];
        api.GET("/Products" + (employerId ? "?employerId=" + employerId : ""), (result) => {
            state.products = result;
            for (let x = 0; x < state.products.length; x++) {
                if (state.products[x].thumbnail.startsWith("Logos/")) {
                    state.products[x].thumbnail = state.products[x].thumbnail.replace('Logos/', 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/Logos/');
                }
                state.products[x].img = state.products[x].thumbnail;
                if (employerId != null && state.products[x].tags.includes("employeeBenefit")) {
                    state.benefits.push(state.products[x]);
                }
                if (state.products[x].tags.includes("calculator")) {
                    state.calculators.push(state.products[x]);
                }
                if (state.products[x].tags.includes("marketplace")) {
                    state.marketplace.push(state.products[x]);
                }
            }
            if (onSuccess)
                onSuccess();
        }, true);
    }
    return { getProducts };
}
